<!-- Main layout, in authenticated mode. Draws a menu and a navbar around the router outlet -->
<div class="app" id="app">

  <!-- Full-width top navigation bar (spans the entire screen, above aside + content) -->
  <div class="app-header navbar-md" gp-authenticated>
    <div class="white">
      <gp-navbar [showChatbot]="showChatbot" (chatbotToggle)="showChatbot = $event"></gp-navbar>
    </div>
  </div>

  <!-- Aside menu -->
  <div *ngIf="!isOnlyNotifications && !isAccessLimited"
       id="aside"
       class="app-aside modal fade folded md nav-expand show-text"
       gp-aside
       gp-modal="aside"
       [gp-modal-closable]="true"
       gp-authenticated>
  </div>

  <div *ngIf="(isMobile && isLandscapeOrientation); else nonMobileLandscapeUI"
       class="info-mobile--landscape alert alert-warning text-center">
    <h3>{{ 'COMMON.no_landscape_support_for_mobile' | translate }}</h3>
    <p>{{ 'COMMON.rotate_your_device' | translate }}</p>
  </div>

  <ng-template #nonMobileLandscapeUI>
    <div class="app-content box-shadow-z0" id="content" role="main">
      <div class="app-body" gp-authenticated-class [class.empty-background]="emptyBackground">
        <router-outlet></router-outlet>
      </div>

    </div>
  </ng-template>

</div>

<!-- Localization hook, allows for toggling RTL dynamically -->
<gp-localization></gp-localization>

<!-- Modal -->
<gp-modal-outlet></gp-modal-outlet>
<gp-modal-backdrop></gp-modal-backdrop>


<gp-platform></gp-platform>
<app-widget-chatbot [open]="showChatbot" (toggle)="showChatbot = !showChatbot"></app-widget-chatbot>

<!-- First-time guided tours (e.g. the new employee/organization sidebar) -->
<gp-guided-tour></gp-guided-tour>

